<template>
  <section>
    <div class="container">
      <div class="cards">
        <div class="card">
          <img :src="$getImgUrl(`assets/stic_creator.webp`)" alt="나도 크리에이터 되기">
          <p>
            다 같이 쓸 수 있는<br>
            이모티콘 작가 돼보기
          </p>
          <button v-on:click="openOCS">나도 크리에이터 되기</button>
        </div>
        <div class="card">
          <img :src="$getImgUrl(`assets/stic_share.webp`)" alt="공유하기">
          <p>
            지인에게 알리고<br>
            이모티콘 함께 쓰기
          </p>
          <button v-on:click="copyToClipboard">공유하기</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    openOCS() {
      return window.open('https://creators.ogq.me/', '_blank')
    },
    copyToClipboard() {
      this.$emit('copyToClipboard')
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  padding: 93px 0 197px;
  @media screen and (max-width: 768px) {
    padding: 22px 0 87px;
  }
}

.cards {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}

.card {
  position: relative;
  background:#F5F5F5;
  border-radius: 10px;
  width: 314px;
  max-width: 100%;
  height: 238px;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 26px;  
  @media screen and (max-width: 768px) {
    margin: 38px auto;
  }
}

img {
  position: absolute;
  display: block;
  width: 148px;
  height: auto;
  left: 50%;
  top: -54px;
  transform: translate3d(-50%, 0, 0)
}

p {
  text-align: center;
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  color: #3A3A3A;
}

button {
  width: 170px;
  height: 40px;
  color: #3B7CF3;
  font-weight: 700;
  background-color: white;
  border-radius: 20px;
  outline: 0;
  border: 0;
  margin-top: 30px;
  &:hover {
    background-color: #3B7CF3;
    color: white;
  }
}

</style>